// extracted by mini-css-extract-plugin
export default {"label":"slider_label__V9P2Z","thumb":"slider_thumb__960vW","mark-label":"slider_mark-label__-oxQO"};